module.exports = __webpack_public_path__ + "f98595d6178ae4180d4f9555a0266984.pdf";